function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatHighlight, isPercent } from '@signal/utils/getStringFormatter';
import { InnerDonut, OuterDonut, Value, ValueWrapper, Wrapper } from './styles';
export function DonutChart(props) {
  var size = props.size,
      thickness = props.thickness,
      value = props.value,
      valueProps = props.valueProps,
      format = props.format,
      colored = props.colored,
      fontWeight = props.fontWeight,
      _props$animate = props.animate,
      animate = _props$animate === void 0 ? true : _props$animate,
      rest = _objectWithoutProperties(props, ["size", "thickness", "value", "valueProps", "format", "colored", "fontWeight", "animate"]);

  var _useState = useState(animate ? 0 : value),
      _useState2 = _slicedToArray(_useState, 2),
      donutValue = _useState2[0],
      setDonutValue = _useState2[1];

  useEffect(function () {
    setDonutValue(value);
  }, [value]);
  var displayString = formatHighlight(value, format, {
    excludePositiveSign: true
  });
  /**
   * Large percentages should still fill the donut completely
   * so if the percentage is greater than 1 we still want it to be 100%.
   */

  var truncatedValue = isPercent(format) ? Math.min(donutValue * 100, 100) : donutValue;
  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    size: size
  }, rest), /*#__PURE__*/React.createElement(OuterDonut, {
    colored: colored,
    size: size,
    thickness: thickness,
    value: 100
  }), /*#__PURE__*/React.createElement(InnerDonut, {
    size: size,
    thickness: thickness,
    value: truncatedValue
  }), /*#__PURE__*/React.createElement(ValueWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(Value, Object.assign({
    size: size,
    fontWeight: fontWeight,
    format: format,
    value: displayString
  }, valueProps), displayString)));
}
DonutChart.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number,
  value: PropTypes.number.isRequired,
  fontWeight: PropTypes.oneOf(['bold', 'normal']),
  colored: PropTypes.bool,
  format: PropTypes.oneOf(['string', 'currency', 'number', 'percent', 'percentage', 'integer', 'decimal'])
};
DonutChart.defaultProps = {
  thickness: 3,
  size: 48,
  colored: false,
  fontWeight: 'normal',
  format: 'integer'
};
export default DonutChart;